module.exports = __webpack_public_path__ + "static/img/shopNone.44ddec43.png";